export const SDK_VERSION = '7.49.0';
